/** [email] 在 [states] props 中的 index */
export const index = {
  emailIndex: 0,
};
